export interface INavigationRoute {
  name: string
  displayName: string
  meta?: { icon: string }
  children?: INavigationRoute[]
  allowedRoles?: string[]
}

export default {
  root: {
    name: '/',
    displayName: 'navigationRoutes.home',
  },
  routes: [
    {
      name: 'dashboard',
      displayName: 'menu.dashboard',
      meta: { icon: 'dashboard' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
    },
    {
      name: 'general-report',
      displayName: 'menu.general-report',
      meta: { icon: 'description' },
      allowedRoles: ['Super Administrateur'],
    },
    {
      name: 'clients',
      displayName: 'menu.clients',
      meta: { icon: 'group' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
      children: [
        {
          name: 'create-client',
          displayName: 'menu.create-client',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'list-clients',
          displayName: 'menu.list-clients',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'archived-clients',
          displayName: 'menu.archived-clients',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
      ],
    },
    {
      name: 'missions',
      displayName: 'menu.missions',
      meta: { icon: 'assignment' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
      children: [
        {
          name: 'create-diligence',
          displayName: 'menu.create-diligence',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'diligence-history',
          displayName: 'menu.diligence-history',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'create-attestation',
          displayName: 'menu.create-attestation',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'create-mission',
          displayName: 'menu.create-mission',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'attestation-history',
          displayName: 'menu.attestation-history',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'mission-history',
          displayName: 'menu.mission-history',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'cancel-attestation',
          displayName: 'menu.cancel-attestation',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
      ],
    },
    {
      name: 'documents',
      displayName: 'menu.documents',
      meta: { icon: 'folder' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
      children: [
        {
          name: 'add-document',
          displayName: 'menu.add-document',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'list-documents',
          displayName: 'menu.list-documents',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
      ],
    },
    {
      name: 'payments',
      displayName: 'menu.payments',
      meta: { icon: 'euro' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
      children: [
        {
          name: 'initiate-payment',
          displayName: 'menu.initiate-payment',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'perform-payment',
          displayName: 'menu.perform-payment',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'payment-history',
          displayName: 'menu.payment-history',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'minipay',
          displayName: 'menu.minipay',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'transfer-journal',
          displayName: 'menu.transfer-journal',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
      ],
    },
    {
      name: 'stickers',
      displayName: 'menu.stickers',
      meta: { icon: 'label' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
      children: [
        {
          name: 'enter-sticker',
          displayName: 'menu.enter-sticker',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'exit-sticker',
          displayName: 'menu.exit-sticker',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'stock-sticker',
          displayName: 'menu.stock-sticker',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
      ],
    },
    {
      name: 'expenses',
      displayName: 'menu.expenses',
      meta: { icon: 'receipt' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
    },
    {
      name: 'receivables',
      displayName: 'menu.receivables',
      meta: { icon: 'account_balance' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
      children: [
        {
          name: 'receivables-list',
          displayName: 'menu.receivables-list',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'non-invoiced',
          displayName: 'menu.non-invoiced',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
      ],
    },
    {
      name: 'contributors',
      displayName: 'menu.contributors',
      meta: { icon: 'people' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
      children: [
        {
          name: 'add-contributor',
          displayName: 'menu.add-contributor',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'list-contributors',
          displayName: 'menu.list-contributors',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'pay-commission',
          displayName: 'menu.pay-commission',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'settle-commission',
          displayName: 'menu.settle-commission',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'commission-history',
          displayName: 'menu.commission-history',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
      ],
    },
    {
      name: 'statistics',
      displayName: 'menu.statistics',
      meta: { icon: 'bar_chart' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
      children: [
        {
          name: 'client-report',
          displayName: 'menu.client-report',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'attestation-report',
          displayName: 'menu.attestation-report',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'mission-report',
          displayName: 'menu.mission-report',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'finance-report',
          displayName: 'menu.finance-report',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'annual-client-report',
          displayName: 'menu.annual-client-report',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
        {
          name: 'fiscal-report',
          displayName: 'menu.fiscal-report',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire'],
        },
      ],
    },
    {
      name: 'communications',
      displayName: 'menu.communications',
      meta: { icon: 'mail' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
      children: [
        {
          name: 'chatbox',
          displayName: 'menu.chatbox',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'mailbox',
          displayName: 'menu.mailbox',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
      ],
    },
    {
      name: 'other',
      displayName: 'menu.other',
      meta: { icon: 'more_vert' },
      allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
      children: [
        {
          name: 'appointments',
          displayName: 'menu.appointments',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'notes',
          displayName: 'menu.notes',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'permission-request',
          displayName: 'menu.permission-request',
          allowedRoles: ['Super Administrateur', 'Administrateur', 'Secrétaire', 'Collaborateur'],
        },
        {
          name: 'manage-permissions',
          displayName: 'menu.manage-permissions',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
      ],
    },
    {
      name: 'settings-main',
      displayName: 'menu.settings',
      meta: { icon: 'settings' },
      allowedRoles: ['Super Administrateur', 'Administrateur'],
      children: [
        {
          name: 'company-settings',
          displayName: 'menu.company',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
        { name: 'users-settings', displayName: 'menu.users', allowedRoles: ['Super Administrateur', 'Administrateur'] },
        { name: 'banks-settings', displayName: 'menu.banks', allowedRoles: ['Super Administrateur', 'Administrateur'] },
        {
          name: 'chatbox-settings',
          displayName: 'menu.chatbox-settings',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
        {
          name: 'mailbox-settings',
          displayName: 'menu.mailbox-settings',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
        {
          name: 'fiscal-regime-settings',
          displayName: 'menu.fiscal-regime',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
        {
          name: 'general-settings',
          displayName: 'menu.general-settings',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
        {
          name: 'attestation-types',
          displayName: 'menu.attestation-types',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
        {
          name: 'mission-types',
          displayName: 'menu.mission-types',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
        {
          name: 'report-types',
          displayName: 'menu.report-types-bilan',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
        {
          name: 'expense-types',
          displayName: 'menu.expense-types',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
        {
          name: 'permission-types',
          displayName: 'menu.permission-types',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
        {
          name: 'objectives',
          displayName: 'menu.objectives',
          allowedRoles: ['Super Administrateur', 'Administrateur'],
        },
      ],
    },
  ] as INavigationRoute[],
}
